import React, { useState } from 'react';
import { Layout, ConfigProvider } from 'antd';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
const { Header, Content } = Layout;
import { routeHistory } from '@nackle/biw-web-router';
import { routeList } from '../../routes.js';
import { ApolloProvider, BridgeAndProvider,  RoutesProvider } from '../../providers/index.js';
import AppHeader from '../components/AppHeader/AppHeader.js';
import AppSidebar from '../components/AppSidebar/AppSidebar.js';
import AppView from '../components/AppView/AppView.js';
import { authService } from '../../auth/authService.js';  
import { CompanyProvider } from '../../providers/companyProvider.js';
import { canShowBIWAdminStuff } from '../../auth/auth.js';
import auth from '../../auth/auth.js';
import './app.less';

let companyUUID = '';

const App = () => {
    const [ showSidebar ] = useState( canShowBIWAdminStuff() );

    return (
        <ConfigProvider
            theme={ {
              token: {
                borderRadius: 4
              },
            } }
          >
        <DndProvider backend={ HTML5Backend }>
        <BridgeAndProvider>
            <ApolloProvider>
                <CompanyProvider>
                    <RoutesProvider render={ ( route ) => {
                        return (
                            <Layout className='app-route' style={ { minHeight: '100vh' } }> 
                                 
                                <Header style={ { padding: '0 24px', position: 'fixed', width: '100%', top: 0, zIndex: 1000 } }>
                                    <AppHeader/>
                                </Header>

                                <Layout style={ { marginTop: '64px', display: 'flex', flexDirection: 'row' } }>
                                    { showSidebar &&
                                        <AppSidebar/>
                                    }
                                    <Content style={ { minWidth: 0 } } >
                                        <AppView>
                                            { route?.match && 
                                                <>
                                                    { React.cloneElement( route.component, { className: 'view' } ) }
                                                </>
                                            }
                                        </AppView>
                                    </Content>
                                
                                </Layout>
                                
                                
                            </Layout>
                        );
                    } }
                    />
                </CompanyProvider>
            </ApolloProvider>
        </BridgeAndProvider>
        </DndProvider>
        </ConfigProvider>
    );
};

routeHistory.applyRoutes( routeList );

routeHistory.applyMiddleware( [ 

    async ( action, nextRoute, _prevRoute ) => {
        if ( canShowBIWAdminStuff() && authService.isAuthenticated() && authService.isAdministrator() ) {
            const match = nextRoute.pathname.match( /^\/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/ );
        
            if ( match ) {
                // Remove the / char at the begining 
                let nextCompanyUUID = match[ 0 ].slice( 1 );
        
                if ( nextCompanyUUID !== '' && nextCompanyUUID !== companyUUID ) {
                    companyUUID = nextCompanyUUID;
                
                    // Switch to the new company
                    auth.delegate( nextCompanyUUID ).then( () => {    
                        action.ok();
                    } ).catch( error => {
                        console.error( error );
                    } );
                } else {
                    action.ok();
                }
            } else {
                action.ok();
            }
        } else {
            return action.ok();
        }
    }
] );

export default App;
